import { useQuery } from '@apollo/client/react';

import { MemberActionFragment, GetMemberActionsDocument, MemberActionType } from '~/types';

export type Action = {
    type: MemberActionType;
    title: string;
    descriptionShort: string;
    actionUrl?: string;
    description: string;
};

export const useMemberActions = () => {
    const { data, loading, error } = useQuery(GetMemberActionsDocument);

    const availableActions = data?.root?.availableActions?.actions ?? [];

    const fragmentToAction = (fragment: MemberActionFragment): Action => {
        return {
            title: fragment.title!,
            descriptionShort: fragment.descriptionShort!,
            description: fragment.description!,
            type: fragment.typeNew!,
            actionUrl: fragment.actionUrl!
        };
    };

    // Prefer server-side grouped fields if available, fallback to legacy category for older servers
    type GroupedActions = {
        root?: {
            availableActions?: {
                contactActions?: MemberActionFragment[];
                nonBusyActions?: MemberActionFragment[];
                exploreActions?: MemberActionFragment[];
            };
        };
    };

    const grouped = (data as unknown as GroupedActions) ?? {};
    const contactActionsGql = grouped.root?.availableActions?.contactActions ?? [];
    const nonBusyActionsGql = grouped.root?.availableActions?.nonBusyActions ?? [];

    const availableContactCategoryActions = (
        contactActionsGql.length ? contactActionsGql : availableActions.filter(action => action.category === 0)
    ).map(fragmentToAction);

    const availableNonBusyCategoryActions = (
        nonBusyActionsGql.length ? nonBusyActionsGql : availableActions.filter(action => action.category === 1)
    ).map(fragmentToAction);

    return {
        loading,
        error,
        contactCategoryActions: availableContactCategoryActions,
        nonBusyCategoryActions: availableNonBusyCategoryActions
    };
};
